import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const PRESETS = ["Prezzo non competitivo", "Scelto un concorrente", "Progetto rinviato", "Budget non disponibile", "Nessuna risposta"];

export const LostReasonDialog = ({ open, onCancel, onConfirm }) => {
  const [reason, setReason] = useState("");
  useEffect(() => { if (open) setReason(""); }, [open]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onCancel()}>
      <DialogContent className="sm:max-w-md" data-testid="lost-reason-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">Opportunità persa</DialogTitle>
          <DialogDescription>Il motivo è obbligatorio: serve per capire e migliorare.</DialogDescription></DialogHeader>
        <div className="flex flex-wrap gap-1.5">{PRESETS.map((p) => <button key={p} type="button" onClick={() => setReason(p)} className="rounded-full border border-line px-2.5 py-1 text-xs text-slate-600 hover:border-brand-200 hover:bg-brand-50">{p}</button>)}</div>
        <div className="space-y-1.5"><Label className="text-xs">Motivo</Label>
          <Textarea rows={3} maxLength={500} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="lost-reason-input" /></div>
        <DialogFooter><Button variant="outline" onClick={onCancel} data-testid="lost-reason-cancel">Annulla</Button>
          <Button variant="destructive" disabled={reason.trim().length < 3} onClick={() => onConfirm(reason.trim())} data-testid="lost-reason-confirm">Segna come persa</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
